
const innovationVolume = {
  path: 'innovationVolume',
  component: resolve => require(['../../../../../pages/modules/securityService/innovationVolume'], resolve),
}

export default innovationVolume
